
import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import Sidennav from '../dashboard/sidenavbar';
import Topnavbar from '../dashboard/topnavbar';
import axios from 'axios';
import { baseurladdress } from "../baseurl"
import Moment from "moment";
import { useNavigate } from "react-router-dom";
import { NavLink } from "react-router-dom";
import * as $ from 'jquery';


function Editstaff() {
    const { staff_id } = useParams();
    const accesstoken = localStorage.getItem("token");
    const accessuserid = localStorage.getItem("id");
    const [filename, setFileName] = useState("");
    const [filestaffname, setFilestaffName] = useState("");
    const [staff_name, setstaff_name] = useState("");
    const [staff_spouse, setstaff_spouse] = useState("");
    const [staff_father, setstaff_father] = useState("");
    const [staff_joinedon, setstaff_joinedon] = useState("");
    const [staff_relievedon, setstaff_relievedon] = useState("");

    const [staff_code, setstaff_code] = useState("");
    const [staff_door, setstaff_door] = useState("");
    const [staff_street, setstaff_street] = useState("");
    const [staff_dob, setstaff_dob] = useState("");
    const [staff_gender, setstaff_gender] = useState("");
    const [staff_place, setstaff_place] = useState("");
    const [staff_district, setstaff_district] = useState("");
    const [staff_state, setstaff_state] = useState("");
    const [staff_cntry, setstaff_cntry] = useState("");
    const [staff_pin, setstaff_pin] = useState("");
    const [staff_email, setstaff_email] = useState("");
    const [staff_brief, setstaff_brief] = useState("");
    const [staff_mobile, setstaff_mobile] = useState("");
    const [staff_phone, setstaff_phone] = useState("");
    const [staff_image, setstaff_image] = useState("");
    const [staff_signature, setstaff_signature] = useState("");
    const [staff_status, setstaff_status] = useState("");
    const [x, setX] = useState("");
    const [xy, setXY] = useState("");
    const [placedat, setplacedat] = useState("");
    const [branch_name, setbranch_name] = useState([]);
    const [cntry_name, setcntry_name] = useState([]);
    const [state_name, setstate_name] = useState([]);
    const [district_name, setdistrict_name] = useState([]);
    const [file, setFile] = useState('');

    const [ButtonDisabled, setisButtonDisabled] = useState("disable");
    const [ButtonsignDisabled, setisButtonsignDisabled] = useState("disable");

    const [staff_department, setstaff_department] = useState([]);
    const [dept, setdept] = useState("");
    const [stype, setstype] = useState("");
    const [staff_branchshift, setstaff_branchshift] = useState([]);
    const [disablePunch, setDisablePunch] = useState(false);
    const Swal = require('sweetalert2')

    // Face enrollment modal state
    const [enrollModalOpen, setEnrollModalOpen] = useState(false);
    const [enrollSamples, setEnrollSamples] = useState([]);
    const [enrollValidating, setEnrollValidating] = useState(false);
    const [faceLoading, setFaceLoading] = useState(false);
    const [faceCameraActive, setFaceCameraActive] = useState(false);
    const videoRef = useRef(null);
    const canvasRef = useRef(null);
    const streamRef = useRef(null);

    const ENROLL_STEPS = [
        { label: "Look straight at the camera", icon: "⬆" },
        { label: "Slowly turn slightly to the LEFT", icon: "⬅" },
        { label: "Slowly turn slightly to the RIGHT", icon: "➡" },
    ];

    let navigate = useNavigate();

    useEffect(() => {
        axios
            .get(baseurladdress + `editstaff/` + staff_id, {
                headers: { Authorization: `Bearer ${accesstoken}` },
            })
            .then((res) => {
                const data = res.data.response;
                setstaff_name(data[0].staff_name);
                setstaff_spouse(data[0].staff_spouse);
                setstaff_father(data[0].staff_father);
                setstaff_code(data[0].staff_code);
                setstaff_door(data[0].staff_door);
                setstaff_street(data[0].staff_street);
                setstaff_dob(data[0].staff_dob);
                setstaff_gender(data[0].staff_gender);
                setstaff_place(data[0].staff_place);
                setstaff_district(data[0].staff_district);
                setstaff_state(data[0].staff_state);
                setstaff_cntry(data[0].staff_cntry);
                setstaff_department(data[0].staff_department);
                setstaff_branchshift(data[0].staff_branchshift);
                setstaff_pin(data[0].staff_pin);
                setstaff_email(data[0].staff_email);
                setstaff_brief(data[0].staff_brief);
                setstaff_mobile(data[0].staff_mobile);
                setstaff_phone(data[0].staff_phone);
                setstaff_image(data[0].staff_image);
                setstaff_signature(data[0].staff_signature);
                setFilestaffName(data[0].staff_signature);
                setstaff_status(data[0].staff_status);
                setplacedat(data[0].staff_placedat)
                setXY(data[0].staff_status);
                const check = (data[0].staff_status == "1") ? true : false;
                setX(check);
                setFileName(data[0].staff_image);
                getbranch();
                getcountry();
                getdept();
                getshifttype();
                getstate(data[0].staff_cntry);
                getdistrict(data[0].staff_state);
                setdept(data[0].staff_department);
                setstype(data[0].staff_branchshift)
                setstaff_joinedon(data[0].staff_joinedon);
                setstaff_relievedon(data[0].staff_relievedon);


               
            });
    }, [staff_id]
    );
    useEffect(() => {
        axios
            .get(baseurladdress + `checkface/${staff_id}`, {
                headers: { Authorization: `Bearer ${accesstoken}` },
            })
            .then((res) => {
                setDisablePunch(res.data.face_exists === 1);
            })
            .catch((err) => {
                console.log(err);
            });
    }, [staff_id]);
    // get imagefilename
    function editUser(filenamelink) {
        axios.get(baseurladdress + 'filedownloads/' + filenamelink, {
            responseType: "blob",
            headers: { Authorization: `Bearer ${accesstoken}` }
        }).then(ress => {
            const file = new Blob([ress.data], {
                type: "application/image"
            });
            const fileURL = URL.createObjectURL(ress.data);
            var fileExtension = filenamelink.split('.').pop();
            const SUPPORTED_FORMATS = ["jpg", "jpeg", "png", "JPG", "JPEG", "PNG", "webp"];
            if (SUPPORTED_FORMATS.includes(fileExtension)) {
                var url = fileURL;
                var img = '<img src="' + url + '">';
                var popup = window.open();
                popup.document.write(img);
            }
            else {
                window.open(fileURL);
            }
        })
    }

    function editSign(filenamelink) {
        axios.get(baseurladdress + 'filedownloads/' + filenamelink, {
            responseType: "blob",
            headers: { Authorization: `Bearer ${accesstoken}` }
        }).then(ress => {
            const file = new Blob([ress.data], {
                type: "application/image"
            });
            const fileURL = URL.createObjectURL(ress.data);
            var fileExtension = filenamelink.split('.').pop();
            const SUPPORTED_FORMATS = ["jpg", "jpeg", "png", "JPG", "JPEG", "PNG", "webp"];
            if (SUPPORTED_FORMATS.includes(fileExtension)) {
                var url = fileURL;
                var img = '<img src="' + url + '">';
                var popup = window.open();
                popup.document.write(img);
            }
            else {
                window.open(fileURL);
            }
        })
    }
    // function previewFile(e) {
    //     // Reading New File (open file Picker Box)
    //     const reader = new FileReader();
    //     // Gettting Selected File (user can select multiple but we are choosing only one)
    //     const selectedFile = e.target.files[0];
    //     if (selectedFile) {
    //       reader.readAsDataURL(selectedFile);
    //     }
    //     // As the File loaded then set the stage as per the file type
    //     reader.onload = (readerEvent) => {
    //       if (selectedFile.type.includes("image")) {
    //         setImagePreview(readerEvent.target.result);
    //       } 
    //     };
    //   }
    //   function clearFiles() {
    //     setImagePreview(null);
    //   }

    // get branchname
    const getbranch = () => {
        axios.get(baseurladdress + `getbranchname`, {
            headers: { Authorization: `Bearer ${accesstoken}` },
        })
            .then(res => {
                const data = res.data.response;
                console.log(data);
                const user = data.map((item, index) => {
                    var selectedd = (item.branch_id == placedat
                    ) ? ' selected' : '';
                    return (
                        <option value={item.branch_id} selected={selectedd}> {item.branch_name} </option>
                    )
                }
                );
                setbranch_name(user);
            }).catch(error => {
                alert(error);
            })
    }

    const getdept = () => {
        axios.get(baseurladdress + `getalldepts`, {
            headers: { Authorization: `Bearer ${accesstoken}` },
        })
            .then(res => {
                const data = res.data.response;
                console.log(data);
                const user = data.map((item, index) => {
                    var selectedd = (item.dept_id == dept
                    ) ? ' selected' : '';
                    return (
                        <option value={item.dept_id} selected={selectedd}> {item.dept_name} </option>
                    )
                }
                );
                setstaff_department(user);
            }).catch(error => {
                alert(error);
            })
    }

    const getshifttype = () => {
        axios.get(baseurladdress + `getallshifttype`, {
            headers: { Authorization: `Bearer ${accesstoken}` },
        })
            .then(res => {
                const data = res.data.response;
                console.log(data);
                const user = data.map((item, index) => {
                    var selectedd = (item.type_id == stype
                    ) ? ' selected' : '';
                    return (
                        <option value={item.type_id} selected={selectedd}> {item.type_name} </option>
                    )
                }
                );
                setstaff_branchshift(user);
            }).catch(error => {
                alert(error);
            })
    }

    // getcountry
    const getcountry = () => {
        axios.get(baseurladdress + `getallcountry`, {
            headers: { Authorization: `Bearer ${accesstoken}` },
        })
            .then(res => {
                const data = res.data.response;
                console.log(data);
                setcntry_name(data);
            }).catch(error => {
                alert(error);
            })
    }
    const getcountryname = (event) => {
        setstaff_state("");
        setstaff_district("");
        setdistrict_name([]);
    }

    const getstatename = (event) => {
        setstaff_district("");
    }

    // getstate
    const getstate = (state) => {
        axios.get(baseurladdress + `getallstates/` + state, {
            headers: { Authorization: `Bearer ${accesstoken}` },
        })
            .then(res => {
                const data = res.data.response;
                console.log(data);
                setstate_name(data);
            }).catch(error => {
                alert(error);
            })
    }

    // get district
    const getdistrict = (district_state) => {
        axios.get(baseurladdress + `getalldistricts/` + district_state, {
            headers: { Authorization: `Bearer ${accesstoken}` },
        })
            .then(res => {
                const data = res.data.response;
                console.log(data);
                setdistrict_name(data);
            }).catch(error => {
                alert(error);
            })
    }

    const changeTitle = (staffcntry) => {
        axios.get(baseurladdress + `getallstates/` + staffcntry, {
            headers: { Authorization: `Bearer ${accesstoken}` },
        })
            .then(res => {
                const data = res.data.response;
                setstate_name(data);
            }).catch(error => {
                alert(error);
            })
    }

    const changeDistricts = (staffdistrict) => {
        axios.get(baseurladdress + `getalldistricts/` + staffdistrict, {
            headers: { Authorization: `Bearer ${accesstoken}` },
        })
            .then(res => {
                const data = res.data.response;
                setdistrict_name(data);
                console.log(district_name);
            }).catch(error => {
                alert(error);
            })
    }

    const onUploadClick = (event) => {
        event.preventDefault();
        setisButtonDisabled("disable");
        // setTimeout(()=> setisButtonDisabled(false), 5000);
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        var data = {
            staff_name: staff_name,
            staff_spouse: staff_spouse,
            staff_father: staff_father,
            staff_code: staff_code,
            staff_door: staff_door,
            staff_street: staff_street,
            staff_dob: staff_dob,
            staff_gender: staff_gender,
            staff_place: staff_place,
            staff_district: staff_district,
            staff_image: filename,
            staff_signature: filestaffname,
            staff_state: staff_state,
            staff_cntry: staff_cntry,
            staff_pin: staff_pin,
            staff_email: staff_email,
            staff_brief: staff_brief,
            staff_mobile: staff_mobile,
            staff_phone: staff_phone,
            staff_status: staff_status,
            staff_placedat: placedat,
            staff_department: dept,
            staff_branchshift: stype,
            staff_joinedon: staff_joinedon,
            staff_relievedon: staff_relievedon,
            staff_updby: accessuserid,
            staff_id: staff_id
        };

        var images = $('#image').val();

        fetch(baseurladdress + "updatestaffdetails", {
            method: "POST",
            headers: {
                Accept: "application/form-data",
                "Content-Type": "application/json",
                Authorization: `Bearer ${accesstoken}`,
            },
            body: JSON.stringify(data),
        })
            .then((res) => res.json())
            .then((result) => {
                if (result["status"] === "updated") {
                    const Toast = Swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 800,
                        timerProgressBar: true,
                        didOpen: (toast) => {
                            toast.addEventListener('mouseenter', Swal.stopTimer)
                            toast.addEventListener('mouseleave', Swal.resumeTimer)
                        }
                    })
                    Toast.fire({
                        icon: 'success',
                        title: ' Edited Successfully'
                    })
                    navigate("/stafflist");
                } else {
                    const Toast = Swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 800,
                        timerProgressBar: true,
                        didOpen: (toast) => {
                            toast.addEventListener('mouseenter', Swal.stopTimer)
                            toast.addEventListener('mouseleave', Swal.resumeTimer)
                        }
                    })
                    Toast.fire({
                        icon: 'error',
                        title: 'Something went wrong'
                    })
                }
            });
    };
    const staffimages = () => {
        const formData = new FormData();
        formData.append('file', file); // appending file
        console.log(file.name);
        if (!isImage(file.name) && file.name != "") {
            const Toast = Swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 800,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener('mouseenter', Swal.stopTimer)
                    toast.addEventListener('mouseleave', Swal.resumeTimer)
                }
            })
            Toast.fire({
                icon: 'error',
                title: 'Please select valid staff image'
            })
        }
        else {
            setFileName(file.name);
            axios.post(baseurladdress + `staffimage/${staff_id}`, formData, {
                headers: { Authorization: `Bearer ${accesstoken}` }
            }).then(res => {
                console.log(res);
                setFile('');
                if (res.data["status"] == "success") {
                    const Toast = Swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 800,
                        timerProgressBar: true,
                        didOpen: (toast) => {
                            toast.addEventListener('mouseenter', Swal.stopTimer)
                            toast.addEventListener('mouseleave', Swal.resumeTimer)
                        }
                    })
                    Toast.fire({
                        icon: 'success',
                        title: 'Image uploaded successfully'
                    })
                }
            }).catch(err => console.log(err))
        }
    }


    const staffsignature = () => {
        const formData = new FormData();
        formData.append('file', file); 
        if (!isImage(file.name) && file.name != "") {
            const Toast = Swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 800,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener('mouseenter', Swal.stopTimer)
                    toast.addEventListener('mouseleave', Swal.resumeTimer)
                }
            })
            Toast.fire({
                icon: 'error',
                title: 'Please select valid staff signature'
            })
        }
        else {
            setFilestaffName(file.name);
            axios.post(baseurladdress + `staffsignature/${staff_id}`, formData, {
                headers: { Authorization: `Bearer ${accesstoken}` }
            }).then(res => {
                console.log(res.data);
                setFile('');
                if (res.data["status"] == "success") {
                    const Toast = Swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 800,
                        timerProgressBar: true,
                        didOpen: (toast) => {
                            toast.addEventListener('mouseenter', Swal.stopTimer)
                            toast.addEventListener('mouseleave', Swal.resumeTimer)
                        }
                    })
                    Toast.fire({
                        icon: 'success',
                        title: 'Signature uploaded successfully'
                    })
                }
            }).catch(err => console.log(err))
        }
    }

    //    single delete
    const Delete = () => {
        if (
            window.confirm(
                "Sure you want to delete this data? This cannot be undo later."
            )
        ) {
            fetch(baseurladdress + `deletestaff/${staff_id}`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json; charset=UTF-8",
                    Authorization: `Bearer ${accesstoken}`,
                },
            }).then((response) => {
                if (response.status === 200) {
                    navigate("/stafflist");
                }
            });
        }
    };

    const handleChangeFile = (e) => {
        setisButtonDisabled("");
        const file = e.target.files[0]; // accesing file
        console.log(file.name);
        setstaff_image(file.name);
        setFile(file); // storing file
    };

    const handleChangeFilee = (e) => {
        setisButtonsignDisabled("");
        const file = e.target.files[0]; // accesing file
        console.log(file.name);
        setstaff_signature(file.name);
        setFile(file); // storing file
    };
    const getExtension = (filename) => {
        var parts = filename.split('.');
        return parts[parts.length - 1];
    }

    const isImage = (filename) => {
        var ext = getExtension(filename);
        switch (ext.toLowerCase()) {
            case 'jpg':
            case 'bmp':
            case 'png':
            case 'jpeg':
            case 'webp':
            case 'JPG':
            case 'JPEG':
            case 'PNG':
                return true;
        }
        return false;
    }

    const startCamera = useCallback(async () => {
        try {
            const stream = await navigator.mediaDevices.getUserMedia({ video: { width: 640, height: 480 } });
            streamRef.current = stream;
            if (videoRef.current) {
                videoRef.current.srcObject = stream;
                await videoRef.current.play();
            }
            setFaceCameraActive(true);
        } catch (e) {
            Swal.fire({ icon: "error", title: "Camera Error", text: "Unable to access camera. Please allow camera permission." });
        }
    }, []);

    const stopCamera = useCallback(() => {
        if (streamRef.current) {
            streamRef.current.getTracks().forEach((t) => t.stop());
            streamRef.current = null;
        }
        setFaceCameraActive(false);
    }, []);

    const captureFrame = useCallback(() => {
        if (!videoRef.current || !canvasRef.current) return null;
        const video = videoRef.current;
        const canvas = canvasRef.current;
        canvas.width = video.videoWidth || 640;
        canvas.height = video.videoHeight || 480;
        canvas.getContext("2d").drawImage(video, 0, 0, canvas.width, canvas.height);
        return canvas.toDataURL("image/jpeg", 0.9);
    }, []);

    const closeEnrollModal = () => {
        stopCamera();
        setEnrollModalOpen(false);
        setFaceLoading(false);
        setEnrollSamples([]);
        setEnrollValidating(false);
    };

    const handleEnrollStep = async () => {
        const imageBase64 = captureFrame();
        if (!imageBase64) return;
        setEnrollValidating(true);
        try {
            const res = await axios.post(
                baseurladdress + "face-validate-sample",
                { imageBase64 },
                { headers: { Authorization: `Bearer ${accesstoken}` } }
            );
            if (res.data.valid) {
                setEnrollSamples((prev) => [...prev, imageBase64]);
            }
        } catch (err) {
            Swal.fire({
                icon: "warning",
                title: `Sample ${enrollSamples.length + 1} Not Accepted`,
                text: err.response?.data?.message || "Could not validate this sample. Try again.",
            });
        } finally {
            setEnrollValidating(false);
        }
    };

    const handleEnrollRetake = () => {
        setEnrollSamples((prev) => prev.slice(0, -1));
    };

    const handleEnrollSubmit = async () => {
        setFaceLoading(true);
        try {
            const res = await axios.post(
                baseurladdress + "face-enroll",
                { staffid: staff_id, images: enrollSamples },
                { headers: { Authorization: `Bearer ${accesstoken}` } }
            );
            if (res.data.success) {
                setDisablePunch(true);
                closeEnrollModal();
                Swal.fire({
                    icon: "success",
                    title: "Face Enrolled!",
                    text: `Face registered using ${res.data.samples} angle${res.data.samples > 1 ? "s" : ""} for better accuracy.`,
                    timer: 2500,
                    showConfirmButton: false,
                });
            } else {
                setEnrollSamples([]);
                setFaceLoading(false);
                Swal.fire({ icon: "error", title: "Enrollment Failed", text: res.data.message || "Please try again." });
            }
        } catch (err) {
            setEnrollSamples([]);
            setFaceLoading(false);
            Swal.fire({ icon: "error", title: "Enrollment Failed", text: err.response?.data?.message || "Something went wrong. Please try again." });
        }
    };

    const handlePunchClick = () => {
        if (disablePunch) return;
        setEnrollSamples([]);
        setEnrollModalOpen(true);
        setTimeout(() => startCamera(), 300);
    };
    return (
        <>
            <Topnavbar />
            <Sidennav />

            {/* ── FACE ENROLLMENT MODAL ──────────────────────────────────── */}
            {enrollModalOpen && (
                <div style={{
                    position: "fixed", top: 0, left: 0, width: "100%", height: "100%",
                    background: "rgba(0,0,0,0.75)", zIndex: 9999,
                    display: "flex", alignItems: "center", justifyContent: "center",
                }}>
                    <style>{`.swal2-container { z-index: 99999 !important; }`}</style>
                    <div style={{
                        background: "#fff", borderRadius: "12px", padding: "24px",
                        width: "500px", maxWidth: "95vw", textAlign: "center",
                    }}>
                        <h5 style={{ marginBottom: "6px" }}>Register Your Face</h5>
                        <p style={{ color: "#666", fontSize: "13px", marginBottom: "12px" }}>
                            Capture 3 angles for accurate recognition. Good lighting, only your face in frame.
                        </p>
                        <div style={{ position: "relative", display: "inline-block", borderRadius: "8px", overflow: "hidden", border: "2px solid #dee2e6", width: "100%" }}>
                            <video ref={videoRef} style={{ width: "100%", display: "block", transform: "scaleX(-1)" }} playsInline muted />
                            <canvas ref={canvasRef} style={{ display: "none" }} />
                        </div>
                        {/* Step progress */}
                        <div style={{ marginTop: "10px" }}>
                            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "0", marginBottom: "8px" }}>
                                {ENROLL_STEPS.map((step, i) => (
                                    <div key={i} style={{ display: "flex", alignItems: "center" }}>
                                        <div style={{
                                            width: "30px", height: "30px", borderRadius: "50%",
                                            background: i < enrollSamples.length ? "#28a745" : i === enrollSamples.length ? "#0d6efd" : "#dee2e6",
                                            color: "white", display: "flex", alignItems: "center", justifyContent: "center",
                                            fontSize: "13px", fontWeight: "bold", flexShrink: 0,
                                        }}>
                                            {i < enrollSamples.length ? "✓" : i + 1}
                                        </div>
                                        {i < ENROLL_STEPS.length - 1 && (
                                            <div style={{ width: "36px", height: "2px", background: i < enrollSamples.length ? "#28a745" : "#dee2e6" }} />
                                        )}
                                    </div>
                                ))}
                            </div>
                            <div style={{ fontSize: "13px", fontWeight: 600, color: enrollSamples.length >= 3 ? "#28a745" : "#0d6efd", marginBottom: "6px" }}>
                                {enrollSamples.length >= 3
                                    ? "✓ All 3 samples captured — click Register to finish"
                                    : `${ENROLL_STEPS[enrollSamples.length].icon} Step ${enrollSamples.length + 1} of 3: ${ENROLL_STEPS[enrollSamples.length].label}`}
                            </div>
                            {enrollSamples.length > 0 && (
                                <div style={{ display: "flex", gap: "8px", justifyContent: "center", marginBottom: "8px" }}>
                                    {enrollSamples.map((img, i) => (
                                        <div key={i} style={{ textAlign: "center" }}>
                                            <img src={img} alt={`Sample ${i + 1}`} style={{
                                                width: "64px", height: "48px", objectFit: "cover",
                                                borderRadius: "4px", border: "2px solid #28a745", transform: "scaleX(-1)",
                                            }} />
                                            <div style={{ fontSize: "10px", color: "#28a745", marginTop: "2px" }}>
                                                {ENROLL_STEPS[i].icon}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                        {/* Buttons */}
                        <div style={{ marginTop: "10px", display: "flex", gap: "10px", justifyContent: "center", flexWrap: "wrap" }}>
                            {enrollSamples.length < 3 && (
                                <button className="btn btn-primary" onClick={handleEnrollStep} disabled={faceLoading || !faceCameraActive || enrollValidating}>
                                    {enrollValidating ? "Checking..." : `Capture Sample ${enrollSamples.length + 1}`}
                                </button>
                            )}
                            {enrollSamples.length > 0 && enrollSamples.length < 3 && (
                                <button className="btn btn-outline-secondary" onClick={handleEnrollRetake} disabled={faceLoading}>
                                    Retake Last
                                </button>
                            )}
                            {enrollSamples.length >= 3 && (
                                <>
                                    <button className="btn btn-success" onClick={handleEnrollSubmit} disabled={faceLoading}>
                                        {faceLoading ? "Registering..." : "Register Face"}
                                    </button>
                                    <button className="btn btn-outline-secondary" onClick={handleEnrollRetake} disabled={faceLoading}>
                                        Retake Last
                                    </button>
                                </>
                            )}
                            <button className="btn btn-secondary" onClick={closeEnrollModal} disabled={faceLoading}>
                                Cancel
                            </button>
                        </div>
                        <p style={{ marginTop: "10px", fontSize: "12px", color: "#999" }}>
                            Your face is stored securely and only used for attendance verification.
                        </p>
                    </div>
                </div>
            )}
            <style>{ `/* Punch Button (Medium) */
.punchfloat {
    position: fixed;
    right: 25px;
    bottom: 100px;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    background-color: #28a745;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    cursor: pointer;
    text-decoration: none;
    box-shadow: 0 4px 8px rgba(0,0,0,.3);
    z-index: 9999;
    transition: all 0.3s ease;
}

.punchfloat:hover {
    background-color: #218838;
    transform: scale(1.05);
}

.mypunch-float {
    font-size: 20px;
}`}</style>
            <div class="content-wrap" style={{ overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
                <div className="container-fluid">
                    <NavLink activeClassName="active-link" to={"/stafflist"}>
                        <div style={{ display: "flex" }}>
                            <a class="float">
                                <i class="fa fa-arrow-left my-float" style={{ "marginTop": "21px" }}></i>
                            </a>
                        </div>
                        
                        <div style={{ display: "flex" }}>
                            <a class="deletefloat" onClick={Delete} >
                                <i class="fa fa-trash mydelete-float" ></i>
                            </a>
                        </div>    
                    </NavLink>
                    <NavLink>
                        <a
                            className="punchfloat"
                            title={disablePunch ? "Face already enrolled" : "Enroll face for attendance"}
                            style={{
                                opacity: disablePunch ? 0.5 : 1,
                                pointerEvents: disablePunch ? "none" : "auto",
                                cursor: disablePunch ? "not-allowed" : "pointer"
                            }}
                            onClick={handlePunchClick}
                        >
                            <i className="fa fa-hand-pointer-o mypunch-float"></i>
                        </a>
                    </NavLink>
                    <form >
                        <div className='row'>
                            <div class="col-xl-6 col-xxl-6">
                                <div class="card">
                                    <div class="card-header">
                                        <h4 class="card-title">Edit Staff Details</h4>
                                    </div>
                                    <div class="card-body">
                                        <div class="basic-form">

                                            <div class="form-row">

                                                <div class="col-sm-5">
                                                    <h6>Staff Name</h6>
                                                    <input type="text"
                                                        class="form-control"
                                                        value={staff_name}
                                                        onChange={(e) => setstaff_name(e.target.value)}
                                                    />
                                                </div>
                                                <div class="col-sm-3 mt-2 mt-sm-0">
                                                    <h6>Staff Code</h6>
                                                    <input type="text" class="form-control" value={staff_code} readOnly
                                                    />
                                                </div>

                                                <div class="col-sm-4 mt-2 mt-sm-0">
                                                    <h6>Department</h6>
                                                    <select
                                                        className="form-control select"
                                                        name="Department"
                                                        value={dept}
                                                        onChange={(e) => { getdept(e.target.value); setdept(e.target.value) }}
                                                    >
                                                        <option value="" disabled >
                                                            Select
                                                        </option>
                                                        {staff_department}
                                                    </select>
                                                </div>

                                                <div class="col-sm-4 mt-2 mt-sm-0">
                                                    <h6>Shift Type</h6>
                                                    <select
                                                        className="form-control select"
                                                        name="Shifttype"
                                                        value={stype}
                                                        onChange={(e) => { getshifttype(e.target.value); setstype(e.target.value) }}
                                                    >
                                                        <option value="" disabled >
                                                            Select
                                                        </option>
                                                        {staff_branchshift}
                                                    </select>
                                                </div>

                                                <div class="col-sm-4 mt-2 mt-sm-0">
                                                    <h6>DOB</h6>
                                                    <input
                                                        type="date"
                                                        className="form-control"

                                                        value={staff_dob === "0000-00-00 00:00:00"
                                                            ? ""
                                                            : Moment(staff_dob).format("YYYY-MM-DD")}
                                                        onChange={(e) => setstaff_dob(e.target.value)}
                                                    />

                                                </div>

                                                <div class="col-sm-4 mt-2 mt-sm-0">
                                                    <h6>Gender</h6>
                                                    <select
                                                        className="form-control select"
                                                        name="employee"
                                                        id="employee"
                                                        value={staff_gender}
                                                        onChange={(e) => setstaff_gender(e.target.value)}
                                                    >

                                                        <option value="" disabled selected>
                                                            Select
                                                        </option>
                                                        <option value="1">
                                                            Male
                                                        </option>
                                                        <option value="2">
                                                            Female
                                                        </option>
                                                        <option value="3">
                                                            Other
                                                        </option>
                                                    </select>

                                                </div>
                                                <div class="col-sm-4 mt-2 mt-sm-0">
                                                    <h6>Mobile</h6>
                                                    <input type="text" class="form-control" value={staff_mobile}
                                                        pattern="[0-9\-\+\s]+" minLength="10" maxLength="14"
                                                        onChange={(e) => setstaff_mobile(e.target.value)}
                                                    />
                                                </div>
                                                <div class="col-sm-4 mt-2 mt-sm-0">
                                                    <h6>Phone</h6>
                                                    <input type="text" class="form-control" value={staff_phone}
                                                        pattern="[0-9\-\+\s]+" minLength="10" maxLength="12"

                                                        onChange={(e) => setstaff_phone(e.target.value)}
                                                    />
                                                </div>
                                                <div class="col-sm-4 mt-2 mt-sm-0">
                                                    <h6>Email</h6>
                                                    <input type="email" class="form-control" value={staff_email}
                                                        onChange={(e) => setstaff_email(e.target.value)}
                                                    />
                                                </div>
                                                <div class="form-group col-md-12">
                                                    <h6>Brief</h6>
                                                    <textarea class="form-control" style={{ height: "7em" }} value={staff_brief}
                                                        onChange={(e) => setstaff_brief(e.target.value)}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-6 col-xxl-6">
                                <div class="card">

                                    <div class="card-body">
                                        <div class="basic-form">
                                            <div class="form-row">
                                                <div class="col-sm-6 mt-2 mt-sm-0">
                                                    <h6>Joining Date</h6>
                                                    <input
                                                        type="date"
                                                        className="form-control"
                                                        value={
                                                            staff_joinedon
                                                                ? Moment(staff_joinedon).format("YYYY-MM-DD")
                                                                : ""
                                                        }
                                                        onChange={(e) => setstaff_joinedon(e.target.value)}
                                                    />
                                                </div>
                                                <div class="col-sm-6 mt-2 mt-sm-0">
                                                    <h6>Relieving Date</h6>
                                                    <input
                                                        type="date"
                                                        className="form-control"
                                                        value={
                                                            staff_relievedon
                                                                ? Moment(staff_relievedon).format("YYYY-MM-DD")
                                                                : ""
                                                        }
                                                        onChange={(e) => setstaff_relievedon(e.target.value)}
                                                    />
                                                </div>
                                                <div class="col-sm-6 mt-2 mt-sm-0">
                                                    <h6>Father Name</h6>
                                                    <input type="text" class="form-control" value={staff_father}
                                                        onChange={(e) => setstaff_father(e.target.value)}
                                                    />
                                                </div>
                                                <div class="col-sm-6 mt-2 mt-sm-0">
                                                    <h6>Spouse Name</h6>
                                                    <input type="text" class="form-control" value={staff_spouse}
                                                        onChange={(e) => setstaff_spouse(e.target.value)}
                                                    />
                                                </div>
                                                <div class="form-group col-md-12">
                                                    <h6>Door</h6>
                                                    <textarea class="form-control text textaddstaff" value={staff_door}
                                                        onChange={(e) => setstaff_door(e.target.value)}
                                                    />
                                                </div>
                                                <div class="col-sm-6 mt-2 mt-sm-0">
                                                    <h6>Street</h6>
                                                    <input type="text" class="form-control" value={staff_street}
                                                        onChange={(e) => setstaff_street(e.target.value)}
                                                    />
                                                </div>
                                                <div class="col-sm-6 mt-2 mt-sm-0">
                                                    <h6>Place</h6>
                                                    <input type="text" class="form-control" value={staff_place}
                                                        onChange={(e) => setstaff_place(e.target.value)}
                                                    />
                                                </div>

                                                <div class="col-sm-4 mt-2 mt-sm-0">
                                                    <h6>Country</h6>
                                                    <select
                                                        className="form-control select"
                                                        name="Country"
                                                        onChange={e => { changeTitle(e.target.value); getcountryname(e); setstaff_cntry(e.target.value) }}
                                                    >
                                                        <option value="" disabled >
                                                            Select
                                                        </option>
                                                        {cntry_name.map((obj) => {
                                                            var selected = (staff_cntry == obj.cntry_id) ? "selected" : "";
                                                            return (
                                                                <option value={obj.cntry_id} selected={selected} >{obj.cntry_name}</option>
                                                            )
                                                        }
                                                        )}
                                                    </select>
                                                </div>
                                                <div class="col-sm-4 mt-2 mt-sm-0">
                                                    <h6>State</h6>
                                                    <select
                                                        className="form-control select"
                                                        name="State"
                                                        onChange={e => { changeDistricts(e.target.value); getstatename(e); setstaff_state(e.target.value) }}
                                                    >
                                                        <option value=""  >
                                                            Select
                                                        </option>
                                                        {state_name.map((obj) => {
                                                            var selected = (staff_state == obj.state_id) ? "selected" : "";
                                                            return (
                                                                <option value={obj.state_id} selected={selected} >{obj.state_name}</option>
                                                            )
                                                        }
                                                        )}
                                                    </select>
                                                </div>
                                                <div class="col-sm-4 mt-2 mt-sm-0">
                                                    <h6>District</h6>
                                                    <select
                                                        className="form-control select"
                                                        name="District"
                                                        onChange={(e) => setstaff_district(e.target.value)}
                                                    >
                                                        <option value=""  >
                                                            Select
                                                        </option>
                                                        {district_name.map((obj) => {
                                                            var selected = (staff_district == obj.district_id) ? "selected" : "";
                                                            return (
                                                                <option value={obj.district_id} selected={selected} >{obj.district_name}</option>
                                                            )
                                                        }
                                                        )}
                                                    </select>
                                                </div>
                                                <div class="col-sm-4 mt-2 mt-sm-0">
                                                    <h6>Branch</h6>
                                                    <select
                                                        className="form-control select"
                                                        name="Branch"
                                                        value={placedat}
                                                        onChange={(e) => setplacedat(e.target.value)}
                                                    >
                                                        <option value="" disabled >
                                                            Select
                                                        </option>
                                                        {branch_name}
                                                    </select>
                                                </div>

                                                <div class="col-sm-4 mt-2 mt-sm-0">
                                                    <h6>Pin</h6>
                                                    <input type="text" class="form-control" placeholder="Pin" value={staff_pin} pattern="[0-9\-\+\s]+" minLength="6" maxLength="6"
                                                        onChange={(e) => setstaff_pin(e.target.value)}
                                                    />
                                                </div>
                                                <div class="col-sm-4 mt-2 mt-sm-0">
                                                    <br />
                                                    <input type="checkbox" name="staff_status" className="selectsingle checku" checked={x} value={xy} id="exampleCheck1"
                                                        onClick={() => { setX(!x); }}
                                                        onChange={(event) => {
                                                            var checked = event.target.checked; if (checked == true) { setstaff_status(1); }
                                                            else { setstaff_status(0); }
                                                        }} /><label className="form__label textal offset-1" for="clienttype">
                                                        Status
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-xl-6 col-xxl-6">
                                <div class="card">

                                    <div class="card-body">
                                        <div class="basic-form">

                                            <div class="form-row">

                                                <div className="col-md-6">
                                                    <h6> Image</h6>
                                                    <input
                                                        type="file"
                                                        className="form-control"
                                                        id="image"
                                                        pattern="[a-zA-Z\s]+"
                                                        onChange={handleChangeFile}

                                                    />
                                                    {/* <img id="Div2" src={file} width="100" height="100" style={{ paddingTop: "3%" }} ></img>
                                                    <img width="100" height="100" style={{ "display": "none", paddingTop: "3%" }} ></img>
                                                    <img id="Div1" width="100" height="100" style={{ "display": "none", paddingTop: "3%" }} ></img>
                                                    <input type="hidden" name="hiddenfile" /> */}
                                                </div>
                                                <div className="col-md-6">
                                                    <h6> Image Name  </h6>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        id="image"
                                                        value={staff_image}
                                                        onClick={() => editUser(staff_image)}
                                                        readOnly
                                                    />
                                                </div>


                                                <div style={{ "paddingLeft": "350px" }}>
                                                    {/* <br /><br /> */}
                                                    <button type="button" class="btn btn-primary " disabled={ButtonDisabled} onClick={staffimages}
                                                    >UPLOAD</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <div class="col-xl-6 col-xxl-6">
                                <div class="card">
                                    <div class="card-body">
                                        <div class="basic-form">
                                            <div class="form-row">
                                                <div className="col-md-6">
                                                    <h6> Signature</h6>
                                                    <input
                                                        type="file"
                                                        className="form-control"
                                                        id="image"
                                                        pattern="[a-zA-Z\s]+"
                                                        onChange={handleChangeFilee}
                                                    />
                                                </div>
                                                <div className="col-md-6">
                                                    <h6> Image Name</h6>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        id="image"
                                                        value={staff_signature}
                                                        onClick={() => editSign(staff_signature)}
                                                        readOnly
                                                    />
                                                </div>
                                                <div style={{ "paddingLeft": "350px" }}>
                                                    {/* <br /><br /> */}
                                                    <button type="button" class="btn btn-primary" disabled={ButtonsignDisabled} onClick={staffsignature}>UPLOAD</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 offset-5" style={{ "paddingLeft": "70px", "marginTop": "37px" }}>
                                <button type="button" class="btn btn-primary mb-2" onClick={handleSubmit} >Update</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>

        </>
    );
}
export default Editstaff;